(function($) {

	'use strict';

	var init = function() {

        var filter = $('.listing-bn__filters')

        filter.find('.listing-bn__filters__select button').click(function() {
            $(this).toggleClass('open')
            $(this).siblings('.listing-bn__filters__list').toggleClass('open')
        })

	};

	$(document).ready(function() {
		init();
	});

})(jQuery);
